import React from "react";
import { ThemeProvider } from "react-jss";

import themes from "../../../../themes";
import { UpgradeMessage } from "./UpgradeMessage";
export const UpgradeBrowser = () => (
  <ThemeProvider theme={themes}>
    <UpgradeMessage />
  </ThemeProvider>
);
